import * as React from "react";

class BottomMenu extends React.Component {
  render(): JSX.Element {
    return (
      <div className="bottom-menu">
        <div className="menu-item">
          <a href="/terms">Terms</a>
        </div>
        <div className="menu-item">
          <a href="/privacypolicy">Privacy Policy</a>
        </div>
      </div>
    );
  }
}

export default BottomMenu;



// WEBPACK FOOTER //
// ./src/components/bottommenu.component.tsx